import { Navigate } from "react-router-dom"
import { AppShell } from "components/dashboard/app-shell"
import { ContattiContent } from "components/contacts/ContattiContent"
import { useUser } from "contexts/UserContext"

export default function ContactsPageNew() {
  const { user, loading } = useUser()

  // Loading state
  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{
          background: `linear-gradient(to bottom right, var(--hexa-bg-gradient-start), var(--hexa-bg-gradient-mid), var(--hexa-bg-gradient-end))`
        }}
      >
        <div className="text-[var(--hexa-text-primary)] text-lg">Caricamento...</div>
      </div>
    )
  }

  // Se non c'è utente e non c'è token, reindirizza al login
  if (!user && !localStorage.getItem('accessToken')) {
    return <Navigate to="/login" replace />
  }

  return (
    <AppShell currentUser={user}>
      <ContattiContent />
    </AppShell>
  )
}
